import { Base64 } from "js-base64";
const fileCanOnlinePreview = (path) => {
  const word = ["doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx"];
  const text = ["txt", "java", "php", "py", "md", "js", "css", "xml", "json"];
  const zip = ["zip", "rar", "jar", "tar", "gzip"];
  const image = ["jpg", "jpeg", "png", "gif"];
  const media = ["mp3", "mp4", "flv"];
  const canView = [...word, ...text, ...zip, ...image, ...media];
  return canView.some((c) => {
    return path.endsWith(`.${c}`);
  });
};
const getOnlinePreviewUrl = (path) => {
  return `https://fileview.oppein.com/onlinePreview?url=${encodeURIComponent(Base64.encode(path))}`;
};
export { fileCanOnlinePreview, getOnlinePreviewUrl };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getOnlinePreviewUrl.js